import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import Header from './Headers';
import MetaTags from 'react-meta-tags';
import ReactGA from 'react-ga';

@inject('store')
@observer
class Disclaimer extends Component {

    componentDidMount() {
        this.initializeReactGA();
        window.scrollTo(0, 0);
        this.props.store.homeType(false);
    }

    initializeReactGA() {
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/disclaimer-revised');
    }

    render() {
        return (
            <div>
                <MetaTags>
                    <title>Revfin</title>
                    <meta name="description" content="Some description."/>
                    <meta property="og:title" content="MyApp"/>
                    <meta property="og:image" content="path/to/image.jpg"/>
                </MetaTags>
                <Header/>
                <section className="banner_text headerbg">
                    <div className="container">
                        <div className="aboutusbanner full-w text-center ">
                            <h1 className="full-w tex-center whitecolor fz-20">Disclaimer Revised</h1>
                        </div>
                    </div>
                </section>

                <section className="pdtb-20">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                <p>The information provided on or through the Website/ Mobile Application is for general
                                    guidance and information purposes only. They do not in any manner indicate any
                                    assurance or opinion of any manner whatsoever. Any information may be prone to
                                    shortcomings, defects or inaccuracies due to technical reasons. Certain information
                                    on Website/ Mobile Application may be on the basis of our own appraisal of the
                                    applicable facts, law and regulations in force at the date hereof.</p>
                                <div className="full-w mgt-15">
                                    <p>No representations or warranties are made (express or implied) as to the
                                        reliability, accuracy or completeness of information appearing on the Website/
                                        Mobile Application. The Company or any of its subsidiaries/Associates/Group
                                        Companies cannot be held liable for any loss (either direct or indirect) arising
                                        directly or indirectly from the use of, or any action taken in on, any
                                        information appearing on this Website/ Mobile Application. Neither the Company
                                        nor any of its subsidiaries/Associates/Group Companies and testify/confirm the
                                        authenticity of the data mentioned in this Website/ Mobile Application and you
                                        are strictly advised to rely on your investigations and take your own
                                        professional advice.</p>

                                </div>
                            </div>

                            <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <img src={require('../images/about_us.png')} className='img-fluid' alt=''/>
                            </div>
                        </div>


                    </div>
                </section>
            </div>
        )
    }
}


export default Disclaimer



// WEBPACK FOOTER //
// ./src/components/disclaimer.js